import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import IsLogin from "../../../Common/IsLogin";
import Http from "../../../Common/Http";
import LoaderComponent from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const VendorPaymentView = () => {
  const { id } = useParams();
  const [payment, setPayment] = useState({});
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPayment = async () => {
      try {
        const response = await Http.get(`accounts/vendor-payments/${id}`);
        setPayment(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching payment:", error);
        setLoading(false);
        setNotFound(true);
      }
    };

    fetchPayment();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD/MM/YYYY");
  };

  return (
    <div className="am-mainpanel">
      <IsLogin />
      <LoaderComponent />
      <div className="am-pagetitle">
        <h5 className="am-title">Vendor Payment Details</h5>
      </div>
      <div className="am-pagebody">
        <div className="card pd-20 pd-sm-40">
          <h6 className="card-body-title mg-sm-b-30">Payment Information</h6>
          
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" />
            </div>
          ) : notFound ? (
            <div className="alert alert-danger m-3">
              Payment not found or you dont have permission to view it.
            </div>
          ) : (
            <div className="card-body">
                {/* General Information Table - Vertical */}
                <h5 className="mb-3">General Information</h5>
                <table className="table table-bordered mb-4">
                  <tbody>
                    <tr>
                      <th width="30%">Payment Number</th>
                      <td>{payment.payment_number || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>{payment.type || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{payment.amount ? `${parseFloat(payment.amount).toFixed(2)}` : "0.00"}</td>
                    </tr>
                    <tr>
                      <th>Payment Date</th>
                      <td>{formatDate(payment.date)}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{payment.description || "N/A"}</td>
                    </tr>
                  </tbody>
                </table>
                
                <div className="row">
                  {/* Vendor Details Table - Horizontal */}
                  <div className="col-md-6">
                    <h5 className="mb-3">Vendor Details</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Vendor Code</th>
                          <th>Vendor Name</th>
                          <th>Contact Person</th>
                          <th>Contact Phone</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{payment.vendor?.code || "N/A"}</td>
                          <td>{payment.vendor?.name || "N/A"}</td>
                          <td>{payment.vendor?.contact_person || "N/A"}</td>
                          <td>{payment.vendor?.contact_phone || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  {/* Bank Details Table - Horizontal */}
                  <div className="col-md-6">
                    <h5 className="mb-3">Bank Details</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Bank Name</th>
                          <th>Branch</th>
                          <th>Account Number</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{payment.bank?.name || "N/A"}</td>
                          <td>{payment.bank?.branch || "N/A"}</td>
                          <td>{payment.bank?.account_number || "N/A"}</td>
                          <td>{payment.bank?.type || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                {/* Transaction Details */}
                <h5 className="mb-3 mt-4">Transaction Details</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Transaction Number</th>
                      <th>Type</th>
                      <th>Flag</th>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{payment.transaction?.transaction_number || "N/A"}</td>
                      <td>{payment.transaction?.type || "N/A"}</td>
                      <td>{payment.transaction?.flag || "N/A"}</td>
                      <td>{formatDate(payment.transaction?.datetime)}</td>
                      <td>{payment.transaction?.amount ? `${parseFloat(payment.transaction.amount).toFixed(2)}` : "0.00"}</td>
                    </tr>
                  </tbody>
                </table>
                
                {/* Audit Information */}
                {/* <h5 className="mb-3 mt-4">Audit Information</h5>
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th width="30%">Created At</th>
                      <td>{formatDate(payment.created_at)}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{formatDate(payment.updated_at)}</td>
                    </tr>
                  </tbody>
                </table> */}
              </div>
            )}
          </div>
        </div>
      </div>
    // </div>
  );
};

export default VendorPaymentView;